import axios from 'axios'

export default {
    /**
     * 查询所有的机房
     */
    async searchAll(data, callback) {
        // 请求后台查询内容
        var res = await axios({
            method: 'post',
            url: 'Device_infAction!searchAll',
            data: data,
        });
        
        res = JSON.parse(res.data.result);
        // 执行回调返回查询内容
        callback(res);
    }
}